var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"header-menu-item flex-row",on:{"click":_vm.listeners.click}},[_c('span',{staticClass:"header-menu-item-text"},[_vm._v(_vm._s(_vm.props.label))]),(_vm.props.icon)?_c('span',{class:("icon fas fa-fw fa-" + (_vm.props.icon))}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }